import React, { useState, memo } from "react";
import { Marker, InfoWindow } from "react-google-maps";

const CustomMarker = ({ position, icon, onClick, user }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseOver = () => setIsHovered(true);
    const handleMouseOut = () => setIsHovered(false);

    const { distance, user_type, street, neighborhood } = user || {};

    return (
        <Marker
            position={position}
            icon={icon}
            onClick={onClick}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
        >
            {distance && (
                <InfoWindow>
                    <div>
                        <p>Distância de {distance} metros</p>
                    </div>
                </InfoWindow>
            )}

            {isHovered && (
                <InfoWindow>
                    <div>
                        <h5>{user_type}</h5>
                        <small>
                            <strong>Endereço: </strong> {street}
                            <br />
                            <strong>Bairro: </strong> {neighborhood}
                        </small>
                    </div>
                </InfoWindow>
            )}
        </Marker>
    );
};

export default memo(CustomMarker);